export default "__VITE_ASSET__5624c9fa__"